import { render, staticRenderFns } from "./heerlijk.vue?vue&type=template&id=6199f304&"
import script from "./heerlijk.vue?vue&type=script&lang=js&"
export * from "./heerlijk.vue?vue&type=script&lang=js&"
import style0 from "./heerlijk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./heerlijk.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CaseIntro: require('/app/components/case/intro.vue').default,CaseContent: require('/app/components/case/content.vue').default,UiIcon: require('/app/components/ui/icon.vue').default,UiTransition: require('/app/components/ui/transition.vue').default,CaseList: require('/app/components/case/list.vue').default,CaseCta: require('/app/components/case/cta.vue').default,CaseRelated: require('/app/components/case/related.vue').default})
